import { create } from "zustand";
import { httpService } from "../../../../base/services/httpService.service";

export const expertsRequestStore = create((set) => ({
   pendingCount: 0,

   fetchPendingCount: () => {
      httpService.get(
         "/Consultants/requests?pageSize=1&pageNumber=1&StatusId=1",
         (res) => {
            set({ pendingCount: res?.metaData?.totalItemCount || 0 });
         },
         () => {}
      );
   }
}));
